import { render, staticRenderFns } from "./qTableHeader.vue?vue&type=template&id=117203ca&"
import script from "./qTableHeader.vue?vue&type=script&lang=ts&"
export * from "./qTableHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports